"use strict";

exports.__esModule = true;
exports.getAdapter = getAdapter;

var _adapterDefault = _interopRequireDefault(require("./default/adapter-default"));

var _adapterStoresProduct = _interopRequireDefault(require("./stores-product/adapter-stores-product"));

var _adapterStaticPage = _interopRequireDefault(require("./static-page/adapter-static-page"));

var _ItemTypes = require("../types/ItemTypes");

var _adapters;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var adapters = (_adapters = {}, _adapters[_ItemTypes.ITEM_TYPES.UNKNOWN] = _adapterDefault["default"], _adapters[_ItemTypes.ITEM_TYPES.STORES_PRODUCT] = _adapterStoresProduct["default"], _adapters[_ItemTypes.ITEM_TYPES.STATIC_PAGE] = _adapterStaticPage["default"], _adapters);

function getAdapter(itemType) {
  return adapters[itemType] || _adapterDefault["default"];
}